import { useCallback, useRef } from "react";
import { useRun } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import getPlasmidSequenceLine from "../../providers/getPlasmidSequenceLine";

const lineId = (setID, plasmidID, lineLength, lineIndex) =>
	[setID, plasmidID, lineLength, lineIndex].join("/");

function useLinesCache() {
	const linesCache = useRef(new Map());
	const getLineHtml = useRun(getPlasmidSequenceLine);

	return useCallback((setID, plasmidID, lineHeight, index) => {
		const cache = linesCache.current;
		const id = lineId(setID, plasmidID, lineHeight, index);
		const htmlPromise =
			cache.get(id) ??
			getLineHtml(setID, plasmidID, lineHeight, index * lineHeight);

		if (!cache.has(id)) cache.set(id, htmlPromise);

		return htmlPromise;
	}, []);
}

export default useLinesCache;
